<template>
  <div>
    <div id="nav">
    </div>

    <router-view />
  </div>
</template>
